export default __webpack_public_path__ + "static/media/failed_run.36bde50a.svg";